import axios from 'axios'

export default {
  getSubscription (subId) {
    return axios.get(`/subscription/${subId}?billing`)
  },
  getSubscriptionBranding (subdomain) {
    return axios.get(`/subscription/branding/${subdomain}`)
  },
  getSubscriptionUsers () {
    return axios.get('/subscription/users')
  },
  patchSubAdmin (userId, data) {
    return axios.patch(`/subscription/user/${userId}/admin`, data)
  },
  patchSubAdminBilling (userId, data) {
    return axios.patch(`/subscription/user/${userId}/billingAdmin`, data)
  },
  patchSubAdminUser (userId, data) {
    return axios.patch(`/subscription/user/${userId}/user`, data)
  },
  deleteUser (userId) {
    return axios.delete(`/subscription/user/${userId}`)
  },
  postNewSubscriber (data) {
    return axios.post('/subscription/self/user', data)
  },
  getActiveRooms () {
    return axios.get('/subscription/rooms')
  },
  getClosedRooms () {
    return axios.get('/subscription/rooms/closed')
  },
  postSubscriptionTeam (data) {
    return axios.post('/subscription/team', data)
  },
  postElectronicVaultQuoteRequest (data) {
    return axios.post('/electronic-vault/quote-request', data)
  },
  patchSubscriptionTeam (teamId, data) {
    return axios.patch(`/subscription/team/${teamId}`, data)
  },
  deleteSubscriptionTeam (teamId) {
    return axios.delete(`/subscription/team/${teamId}`)
  },
  getSubscriptionTeams () {
    return axios.get('/subscription/teams')
  },
  getSubscriptionDataroomStorage () {
    return axios.get('/subscription/consumption')
  },
  getSubscriptionDrPlanHistory () {
    return axios.get('/subscription/dataroom-plan/history')
  },
  getSubscriptionDrPpu () {
    return axios.get('/subscription/datarooms/pay-per-use')
  },
  postSubscriptionDrPpuStorageAddon (roomId, data) {
    return axios.post(`/subscription/datarooms/pay-per-use/${roomId}/storage-addon`, data)
  },
  getSubscriptionDrPpuHistory () {
    return axios.get('/subscription/datarooms/pay-per-use/history')
  },
  getSeats () {
    return axios.get('/subscription/seats')
  },
  getSubscriptionInvoices () {
    return axios.get('/subscription/invoices')
  },
  downloadInvoices (data) {
    return axios.get('/subscription/download/invoices', { params: data })
  },
  restoreRoom (roomId, data) {
    return axios.patch(`/subscription/room/${roomId}/restore`, data)
  },
  shareSubscriptionConsumptionPack ({ packId, data }) {
    return axios.post(`/subscription/consumption/packs/${packId}/share`, data)
  },
  shareSubscriptionDataroomPlan ({ data }) {
    return axios.post(`/subscription/dataroom-plan/share`, data)
  },
  shareSubscriptionDrPpu ({ roomId, data }) {
    return axios.post(`/subscription/datarooms/pay-per-use/${roomId}/share`, data)
  },
  getSignaturesCountStats (subId, params = {}) {
    return axios.get(`/subscription/${subId}/envelopesCount/stats`, { params })
  },
}
